import {
  DeleteOutlined,
  MinusOutlined,
  SaveOutlined,
  UserOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Popconfirm,
  Row,
  Space,
  Spin,
  Switch,
  Table,
  Tag,
  Tooltip,
  message
} from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Label } from '../../components';
import LabelValidateMessage from '../../components/LabelValidateMessage';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import SelectableListModal from '../../components/SelectableListModal';
import {
  errorHandler,
  gruposAprobadoresPorTipo,
  gruposSistema,
  tiposAutorizacion
} from '../../utils';
import { instanceRef } from '../../utils/axios';
import { formatoMonedaGenerico } from '../../utils/converters';
import AutorizacionTipoValidacionForm from './AutorizacionTipoValidacionForm';
import ConfiguracionRolesModal from './ConfiguracionRolesModal';
import ControlProductoActividad from './ControlProductoActividad';
import ControlProductoModal from './ControlProductoModal';

const columnsAprobador = [
  {
    title: 'Nombres',
    dataIndex: 'nombres',
    key: 'nombres'
  },
  {
    title: 'Rol',
    dataIndex: 'grupo',
    key: 'grupo',
    render: (grupo) => gruposSistema[grupo]
  }
];

const columnsEjecutivoCartera = [
  {
    title: 'Nombres',
    dataIndex: 'nombres',
    key: 'nombres'
  },
  {
    title: 'Rol',
    dataIndex: 'grupo',
    key: 'grupo',
    render: (grupo) => gruposSistema[grupo]
  }
];

const AutorizacionConfig = () => {
  const {
    params: { id: idTipo, tipo: tipoParam, tipoValidacion }
  } = useRouteMatch();
  const [loading, setLoading] = useState();
  const [urlUsuarios, setUrlUsuarios] = useState();
  const [urlUsuariosEjecutivos, setUrlUsuariosEjecutivos] = useState();
  const [, setNewAprobadores] = useState([]); // Se puede seleccionar solo un aprobador
  const [, setNewEjecutivoCartera] = useState([]);
  const [tipo, setTipo] = useState(); // AseguradoraProducto - EmpresaProducto - AseguradoraEmpresaProducto
  const tipoValidacionObj = tiposAutorizacion.find(
    (item) => item.key === tipoValidacion
  );
  const [validateMessage, setValidateMessage] = useState();
  const [count, setCount] = useState(0);
  const [, setRolConfigList] = useState();
  const [newAutorizacionConfigList, setNewAutorizacionConfigList] = useState();
  const [newAutorizacionConfig, setNewAutorizacionConfig] = useState();
  const [, setAutorizacionConfigSelected] = useState();
  const [controlProductoList, setControlProductoList] = useState();
  const [
    aseguradoraProductoToClone,
    setAseguradoraProductoToClone
  ] = useState();

  const rolesList =
    tipoParam === 'aseguradoraProducto' ||
    tipoParam === 'aseguradoraEmpresaProducto'
      ? gruposAprobadoresPorTipo.ASEGURADORA
      : gruposAprobadoresPorTipo.EMPRESA;
  const columnsMonto = [
    {
      title: 'Rango desde',
      // dataIndex: 'rango_desde',
      key: 'rango_desde',
      render: (record) => {
        const { moneda, rango_desde } = record;
        return formatoMonedaGenerico(moneda, rango_desde);
      }
    },
    {
      title: 'Rango Hasta',
      // dataIndex: 'rango_hasta',
      key: 'rango_hasta',
      render: (record) => {
        const { moneda, rango_hasta } = record;
        return formatoMonedaGenerico(moneda, rango_hasta);
      }
    }
  ];
  const orden = [
    'EJECUTIVO',
    'EJECUTIVO_ASEGURADORA',
    'ADMIN_SUCURSAL',
    'ADMIN_EMPRESA',
    'ADMIN_ASEGURADORA',
    'ADMIN'
  ];
  const columnsDescuento = [
    {
      title: 'Rango desde',
      // dataIndex: 'rango_desde',
      key: 'rango_porcentaje_desde',
      render: (record) => {
        const { rango_porcentaje_desde } = record;
        return `${rango_porcentaje_desde} %`;
      }
    },
    {
      title: 'Rango Hasta',
      // dataIndex: 'rango_hasta',
      key: 'rango_porcentaje_hasta',
      render: (record) => {
        const { rango_porcentaje_hasta } = record;
        return `${rango_porcentaje_hasta} %`;
      }
    }
  ];

  let columnsPorTipoValidacion = [];
  if (tipoValidacion === 'monto' || tipoValidacion === 'montoitem') {
    columnsPorTipoValidacion = columnsMonto;
  } else if (tipoValidacion === 'descuento') {
    columnsPorTipoValidacion = columnsDescuento;
  }
  const columnsAutorizacionConfig = [
    {
      title: 'Producto',
      dataIndex: [`${tipoParam}`, 'producto', 'descripcion'],
      key: 'producto'
    },
    ...columnsPorTipoValidacion,
    {
      title: 'Resumen Roles',
      key: 'resumen_roles',
      render: (record) => {
        const { autorizacionConfigDetalles } = record;
        if (autorizacionConfigDetalles) {
          const autorizacionConfigDetallesOrdenados = autorizacionConfigDetalles.sort(
            (n1, n2) =>
              orden.findIndex((item) => item === n2.rol) -
              orden.findIndex((item) => item === n1.rol)
          );
          return (
            <ul>
              {autorizacionConfigDetallesOrdenados.map((item, index) => {
                const rolDescripcion = gruposSistema[item.rol];

                return (
                  <li key={index}>{`${rolDescripcion}: ${item.cantidad}`}</li>
                );
              })}
            </ul>
          );
        }
        return '';
      }
    },
    {
      title: 'Aprobador Gerencial',
      dataIndex: ['usuario'],
      key: 'id_usuario',
      render: (record) => {
        if (record) {
          const { id, nombres, grupo } = record;
          return (
            <ul>
              <li key={id}>{`${nombres} - ${gruposSistema[grupo]}`}</li>
            </ul>
          );
        }
        return '';
      }
    },
    {
      title: 'Ejecutivo Cartera',
      dataIndex: ['ejecutivoCartera'],
      key: 'id_ejecutivo_cartera',
      render: (record) => {
        if (record) {
          const { id, nombres } = record;
          return (
            <ul>
              <li key={id}>{`${nombres}`}</li>
            </ul>
          );
        }
        return '';
      }
    },
    {
      title: 'Activo',
      dataIndex: 'validar',
      render: (record) => {
        let estadoUpperCase;
        let color = 'white';
        if (record) {
          color = 'green';
          estadoUpperCase = 'ACTIVO';
        } else {
          color = 'orange';
          estadoUpperCase = 'INACTIVO';
        }
        return (
          <Tag color={color} key={estadoUpperCase}>
            {estadoUpperCase}
          </Tag>
        );
      },
      width: '10%'
    },
    {
      title: 'Acciones',
      key: 'action',
      width: '10px',
      align: 'left',
      render: (text, record, index) => {
        const aprobador = record.usuario && {
          label: record.usuario.nombres,
          value: record.usuario.id,
          checked: true,
          id: record.usuario.id
        };
        const ejecutivoCartera = record.ejecutivoCartera && {
          label: record.ejecutivoCartera.nombres,
          value: record.ejecutivoCartera.id,
          checked: true,
          id: record.ejecutivoCartera.id
        };
        return (
          <Space size="small">
            <Tooltip title="Editar rango">
              <AutorizacionTipoValidacionForm
                tipo={tipoValidacion}
                data={record}
                {...{
                  newAutorizacionConfig,
                  setNewAutorizacionConfig,
                  newAutorizacionConfigList
                }}
                disabled={index === newAutorizacionConfigList.length - 1}
              />
            </Tooltip>
            <ConfiguracionRolesModal
              roles={rolesList}
              initialValues={record.autorizacionConfigDetalles || []}
              idAutorizacionConfig={record.id}
              rowConfig={record.row}
              {...{ setRolConfigList }}
              extra={{ setearArreglo: setearArregloRol }}
            />
            <SelectableListModal
              title="Aprobador Gerencial"
              listChecked={aprobador ? [aprobador] : []}
              isMultiple={false}
              setNewList={setNewAprobadores}
              columnsData={columnsAprobador}
              url={urlUsuarios}
              width={800}
              iconButton={<UserOutlined />}
              setData={setAutorizacionConfigSelected}
              data={record}
              extra={{ setearArreglo: setearAprobadorGerencial }}
            />
            <SelectableListModal
              title="Ejecutivo Cartera"
              listChecked={ejecutivoCartera ? [ejecutivoCartera] : []}
              isMultiple={false}
              setNewList={setNewEjecutivoCartera}
              columnsData={columnsEjecutivoCartera}
              url={urlUsuariosEjecutivos}
              width={800}
              iconButton={<UserOutlined />}
              setData={setAutorizacionConfigSelected}
              data={record}
              extra={{ setearArreglo: setearEjecutivoCartera }}
            />

            <Tooltip title="Validar" key="validar">
              <Switch
                checkedChildren="Activo"
                unCheckedChildren="Inactivo"
                checked={record.validar}
                onChange={(validar) =>
                  validarAutorizacionConfig(validar, record)
                }
              />
            </Tooltip>

            <Tooltip title="Eliminar" key="eliminar">
              <Popconfirm
                placement="topLeft"
                title="¿Está seguro? Se eliminará la Configuración"
                onConfirm={() => deleteAutorizacionConfig(record)}
                okText="Si"
                cancelText="No"
                disabled={
                  !(
                    record.tipo_validacion === 'MONTO' ||
                    record.tipo_validacion === 'MONTOITEM' ||
                    record.tipo_validacion === 'DESCUENTO'
                  )
                }
              >
                <Button
                  type="text"
                  icon={<DeleteOutlined />}
                  size="middle"
                  disabled={
                    !(
                      record.tipo_validacion === 'MONTO' ||
                      record.tipo_validacion === 'MONTOITEM' ||
                      record.tipo_validacion === 'DESCUENTO'
                    )
                  }
                />
              </Popconfirm>
            </Tooltip>
            {tipoValidacion === 'vehiculo' && (
              <ControlProductoModal
                tipoValidacion={tipoValidacion}
                idAutorizacionConfig={record.id}
                autorizacionConfig={newAutorizacionConfigList}
                controlProductoList={record.cP}
                setControlProductoList={setControlProductoList}
                idAseguradora={
                  record.aseguradoraProducto?.id_aseguradora ||
                  record.aseguradoraEmpresaProducto?.aseguradoraEmpresa
                    ?.id_aseguradora
                }
                idProducto={
                  record.aseguradoraProducto?.id_producto ||
                  record.aseguradoraEmpresaProducto?.id_producto
                }
                loading={loading}
                setLoading={setLoading}
                update={update}
                producto={tipo.producto}
              />
            )}

            {tipoValidacion === 'zona' && (
              <ControlProductoModal
                tipoValidacion={tipoValidacion}
                idAutorizacionConfig={record.id}
                autorizacionConfig={newAutorizacionConfigList}
                controlProductoList={record.cP}
                setControlProductoList={setControlProductoList}
                idAseguradora={
                  record.aseguradoraProducto?.id_aseguradora ||
                  record.aseguradoraEmpresaProducto?.aseguradoraEmpresa
                    ?.id_aseguradora
                }
                idProducto={
                  record.aseguradoraProducto?.id_producto ||
                  record.aseguradoraEmpresaProducto?.id_producto
                }
                loading={loading}
                setLoading={setLoading}
                update={update}
                producto={tipo.producto}
              />
            )}
            {tipoValidacion === 'actividad' && (
              <ControlProductoActividad
                autorizacionConfig={newAutorizacionConfigList[0]}
                upsertAutorizacionConfig={upsertAutorizacionConfig}
                loading={loading}
                setLoading={setLoading}
                idAseguradora={
                  record.aseguradoraProducto?.id_aseguradora ||
                  record.aseguradoraEmpresaProducto?.aseguradoraEmpresa
                    ?.id_aseguradora
                }
                idProducto={
                  record.aseguradoraProducto?.id_producto ||
                  record.aseguradoraEmpresaProducto?.id_producto
                }
              />
            )}
          </Space>
        );
      }
    }
  ];

  const headTable = () => {
    return {
      title: () => (
        <Row gutter={8}>
          {' '}
          <Col flex="none">
            <Space>
              <AutorizacionTipoValidacionForm
                tipo={tipoValidacion}
                {...{
                  newAutorizacionConfig,
                  setNewAutorizacionConfig,
                  newAutorizacionConfigList,
                  setNewAutorizacionConfigList,
                  setCount,
                  setLoading
                }}
                mostrarCopiarConfig={
                  count === 0 && tipoParam === 'aseguradoraEmpresaProducto'
                }
                idAseguradoraProducto={
                  aseguradoraProductoToClone && aseguradoraProductoToClone.id
                }
                idAseguradoraEmpresaProducto={
                  tipoParam === 'aseguradoraEmpresaProducto' ? idTipo : null
                }
              />

              {(tipoValidacion === 'monto' ||
                tipoValidacion === 'montoitem' ||
                tipoValidacion === 'descuento') &&
                newAutorizacionConfigList &&
                newAutorizacionConfigList.length > 1 && (
                  <Space size="small">
                    <Button
                      key="estandar"
                      type="dashed"
                      shape="round"
                      icon={<MinusOutlined />}
                      size="large"
                      onClick={inactivarTodos}
                    >
                      Inactivar todos
                    </Button>
                    <Popconfirm
                      placement="topLeft"
                      title="¿Está seguro? Se eliminarán todas las configuraciones"
                      onConfirm={deleteAllAutorizacionConfig}
                      okText="Si"
                      cancelText="No"
                    >
                      <Button
                        key="estandar"
                        type="dashed"
                        shape="round"
                        icon={<DeleteOutlined />}
                        size="large"
                      >
                        Eliminar todos
                      </Button>
                    </Popconfirm>
                  </Space>
                )}
            </Space>
          </Col>
        </Row>
      )
    };
  };

  const inactivarTodos = () => {
    const auxList = newAutorizacionConfigList.map((item) => {
      const element = item;

      if (element.validar) {
        element.validar = false;
        element.editado = true;
      }

      return element;
    });
    setNewAutorizacionConfigList(auxList);
  };

  const deleteAutorizacionConfig = (record) => {
    const auxList = newAutorizacionConfigList.map((item) => {
      const element = item;

      if ((item.id && item.id === record.id) || item.row === record.row) {
        element.eliminado = true;
        return { ...record, ...element };
      }
      return element;
    });
    setNewAutorizacionConfigList(auxList);
    update();
  };

  const deleteAllAutorizacionConfig = () => {
    const auxList = newAutorizacionConfigList.map((item) => {
      const element = item;
      if (!element.eliminado) {
        element.eliminado = true;
      }

      return element;
    });
    setNewAutorizacionConfigList(auxList);
    update();
  };

  const validarAutorizacionConfig = (validar, record) => {
    const auxList = newAutorizacionConfigList.map((item) => {
      const element = item;

      if ((item.id && item.id === record.id) || item.row === record.row) {
        element.validar = validar;
        element.autorizado = true;
        return { ...record, ...element };
      }
      return element;
    });
    setNewAutorizacionConfigList(auxList);
    if (
      tipoValidacion === 'zona' ||
      tipoValidacion === 'vehiculo' ||
      tipoValidacion === 'actividad'
    )
      update(auxList);
  };

  const handleAdd = () => {
    let agregarRow = false;
    const auxList = newAutorizacionConfigList.map((item) => {
      const element = item;

      if (
        (item.id && item.id === newAutorizacionConfig.id) ||
        item.row === newAutorizacionConfig.row
      ) {
        if (item.rango_hasta === null) {
          agregarRow = true;
        }
        newAutorizacionConfig.editado = !!(
          item.id && item.id === newAutorizacionConfig.id
        );

        return { ...element, ...newAutorizacionConfig };
      }
      return element;
    });

    if (
      tipoValidacion === 'monto' ||
      tipoValidacion === 'montoitem' ||
      tipoValidacion === 'descuento'
    ) {
      if (agregarRow) {
        // si el ultimo de la lista no tiene valor infinito, entonces se agrega una fila
        let auxModel = {
          ...auxList[auxList.length - 1],
          id: null,
          token: null,
          row: Number(count + 2),
          editado: null
        };

        const autorizacionConfigDetalleList = !auxModel.autorizacionConfigDetalles
          ? []
          : auxModel.autorizacionConfigDetalles.map((item) => {
              const detalle = item;
              detalle.id = null;
              detalle.id_autorizacion_config = null;
              return detalle;
            });
        if (tipoValidacion === 'monto' || tipoValidacion === 'montoitem') {
          auxModel = {
            ...auxModel,
            rango_desde:
              Number(auxList[auxList.length - 1].rango_hasta + 1) ||
              newAutorizacionConfig.rango_hasta + 1,
            rango_hasta: null,
            autorizacionConfigDetalles: autorizacionConfigDetalleList
          };
        } else if (tipoValidacion === 'descuento') {
          auxModel = {
            ...auxModel,
            rango_porcentaje_desde:
              Number(auxList[auxList.length - 1].rango_porcentaje_hasta + 1) ||
              newAutorizacionConfig.rango_hasta + 1,
            rango_porcentaje_hasta: Number(100),
            autorizacionConfigDetalles: autorizacionConfigDetalleList
          };
        }
        auxList.push(auxModel);
        setCount(Number(count + 1));
      }
    }
    setNewAutorizacionConfigList(auxList);
  };
  const fetchMonedas = async () => {
    try {
      const monedasResponse = await instanceRef.instance.get(`/moneda`);
      return monedasResponse.data?.data;
    } catch (error) {
      errorHandler(error);
      return null;
    }
  };

  const addNuevaConfig = useCallback(async () => {
    try {
      const monedas = await fetchMonedas();
      const tipoUpperCase = tipoValidacionObj.key.toUpperCase();
      const newData = {
        row: 1,
        rango_desde:
          tipoUpperCase === 'MONTO' || tipoUpperCase === 'MONTOITEM'
            ? Number(0)
            : null,
        rango_hasta: null,
        validar: true,
        id_moneda:
          (tipoUpperCase === 'MONTO' ||
            tipoUpperCase === 'MONTOITEM' ||
            tipoUpperCase === 'CUMULO') &&
          monedas
            ? monedas.find((item) => item.codigo === 'gs').id
            : null,
        tipo_validacion: tipoValidacionObj.key.toUpperCase()
      };
      setNewAutorizacionConfigList([newData]);
      setCount(0);
    } catch (error) {
      errorHandler(error);
    }
  }, [tipoValidacionObj.key]);

  const getAutorizacionesConfig = useCallback(async () => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get('/autorizacion/config', {
        params: { id: idTipo, tipo: tipoParam }
      });
      const autorizacionConfigListResponse = response.data?.data;
      if (autorizacionConfigListResponse) {
        if (autorizacionConfigListResponse.length > 0) {
          let row = 0;
          const autorizacionConfigListByTipoValidacion = autorizacionConfigListResponse.filter(
            (item) => {
              // TODO: Llevar filtro de tipoValidacion en el backend
              if (
                item.tipo_validacion.toUpperCase() ===
                tipoValidacionObj.key.toUpperCase()
              ) {
                const autorizacionConfig = item;
                row = Number(row + 1);
                autorizacionConfig.row = row;

                return autorizacionConfig;
              }
              return null;
            }
          );
          if (autorizacionConfigListByTipoValidacion.length > 0) {
            setCount(row);
            setNewAutorizacionConfigList(
              autorizacionConfigListByTipoValidacion
            );
          } else {
            await addNuevaConfig();
          }
        } else {
          await addNuevaConfig();
        }
      }
      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  }, [addNuevaConfig, idTipo, tipoParam, tipoValidacionObj.key]);

  const upsertAutorizacionConfig = useCallback(
    async (list) => {
      setLoading(true);
      try {
        const response = await instanceRef.instance.post(
          `autorizacion/config`,
          list,
          {
            params: { id: Number(idTipo), tipo: tipoParam }
          }
        );
        if (response.data) {
          await getAutorizacionesConfig();
        }
        setLoading(false);
      } catch (error) {
        errorHandler(error);
      }
      setLoading(false);
    },
    [getAutorizacionesConfig, idTipo, tipoParam]
  );

  const getTipo = async () => {
    setLoading(true);
    try {
      let urlTipo = '';
      if (tipoParam === 'aseguradoraProducto') {
        urlTipo = `/aseguradoraproducto/aseguradoraproducto/${idTipo}`;
      } else if (tipoParam === 'aseguradoraEmpresaProducto') {
        urlTipo = `/aseguradoraempresaproducto/${idTipo}`;
      } else if (tipoParam === 'empresaProducto') {
        urlTipo = `/empresaProducto/${idTipo}`;
      }

      if (urlTipo) {
        const response = await instanceRef.instance.get(urlTipo, {});
        const data = response.data?.data;
        if (data) {
          if (tipoParam === 'aseguradoraProducto') {
            const tipoObj = {
              id: data.id,
              idAseguradora: data.aseguradora.id,
              tipo: data.aseguradora.descripcion || '',
              producto: data.producto
            };
            setTipo(tipoObj);
          } else if (tipoParam === 'aseguradoraEmpresaProducto') {
            const tipoObj = {
              id: data.aseguradoraEmpresa.id,
              idEmpresa: data.aseguradoraEmpresa.empresa.id,
              idAseguradora: data.aseguradoraEmpresa.aseguradora.id,
              tipo:
                ` ${data.aseguradoraEmpresa.aseguradora.descripcion} - ${data.aseguradoraEmpresa.empresa.nombre_corto}` ||
                '',
              producto: data.producto
            };
            setTipo(tipoObj);
            try {
              const responseAsegProd = await instanceRef.instance.post(
                `/aseguradoraproducto/searchproducto`,
                {
                  id_aseguradora: tipoObj.idAseguradora,
                  id_producto: tipoObj.producto.id
                }
              );
              if (responseAsegProd.data?.data) {
                setAseguradoraProductoToClone(responseAsegProd.data?.data);
              }
            } catch (error) {
              setLoading(false);
              errorHandler(error);
            }
          } else if (tipoParam === 'empresaProducto') {
            const tipoObj = {
              id: data.id,
              idEmpresa: data.empresa.id,
              tipo: data.empresa.nombre_corto || '',
              producto: data.producto
            };
            setTipo(tipoObj);
          }
        }
      }
      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };
  const validateValues = useCallback(() => {
    let msg = null;

    if (
      tipoValidacion === 'monto' ||
      tipoValidacion === 'montoitem' ||
      tipoValidacion === 'descuento'
    ) {
      const listOrdenado = newAutorizacionConfigList
        .filter((item) => !item.eliminado)
        .sort((n1, n2) => n1.rango_desde - n2.rango_desde);
      for (let i = 0; i < listOrdenado.length; i += 1) {
        const autorizacionConfigActual = listOrdenado[i];
        const autorizacionConfigSgte = listOrdenado[i + 1];
        if (autorizacionConfigSgte) {
          const hastaActual =
            tipoValidacion === 'descuento'
              ? autorizacionConfigActual.rango_porcentaje_hasta
              : autorizacionConfigActual.rango_hasta;
          const desdeSgte =
            autorizacionConfigSgte && tipoValidacion === 'descuento'
              ? autorizacionConfigSgte.rango_porcentaje_desde
              : autorizacionConfigSgte.rango_desde;
          if (desdeSgte <= hastaActual) {
            msg = 'Existen rangos Solapados';
          } else if (Number(desdeSgte - hastaActual) > 1) {
            msg = 'Existen rangos Libres';
          }
        }
        if (
          !autorizacionConfigActual.autorizacionConfigDetalles ||
          autorizacionConfigActual.autorizacionConfigDetalles.length === 0
        ) {
          msg = 'Debe contar con al menos una cadena de Autorización';
        }
      }
    }

    return msg;
  }, [newAutorizacionConfigList, tipoValidacion]);

  const addUpdateOrDeleteControlProductoList = useCallback(async () => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.post(
        `/control`,
        controlProductoList
      );
      if (response.data) {
        getAutorizacionesConfig();
      }
      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  }, [controlProductoList, getAutorizacionesConfig]);

  const update = useCallback(
    async (dataAutorizacion, dataControl) => {
      const listAutorizacion = dataAutorizacion || newAutorizacionConfigList;
      const listControl = dataControl || controlProductoList;
      setLoading(true);
      const messageValidateValues = validateValues(listAutorizacion);
      setValidateMessage(messageValidateValues);
      if (!messageValidateValues) {
        let controlProdAgregado = false;
        // Si autorizacionConfig.editado es true entonces se realiza un eliminado logico y se vuelve a crear una nueva config

        const autorizacionConfigToUpdateList = listAutorizacion.filter(
          (autorizacionConfig) => {
            return (
              !autorizacionConfig.id ||
              autorizacionConfig.eliminado ||
              autorizacionConfig.editado ||
              autorizacionConfig.autorizado
            );
          }
        );
        if (
          autorizacionConfigToUpdateList &&
          autorizacionConfigToUpdateList.length > 0
        ) {
          if (
            tipoValidacion !== 'zona' &&
            tipoValidacion !== 'vehiculo' &&
            tipoValidacion !== 'actividad'
          ) {
            await upsertAutorizacionConfig(autorizacionConfigToUpdateList);
          } else {
            // Vehiculo y Zona pueden tener controlProducto, en este caso solo existe una sola autConfig
            if (listControl && listControl.length > 0) {
              // Se crea una lista de ControlProducto. Si la autConfig es insertada (se crea o fue editado)
              autorizacionConfigToUpdateList[0].cP = listControl;
              controlProdAgregado = true;
            }

            // eslint-disable-next-line no-await-in-loop
            await upsertAutorizacionConfig([autorizacionConfigToUpdateList[0]]);
          }
        }

        if (listControl && listControl.length > 0 && !controlProdAgregado) {
          await addUpdateOrDeleteControlProductoList();
        }

        message.success('¡Proceso guardado con éxito!');
      }
      setLoading(false);
    },
    [
      addUpdateOrDeleteControlProductoList,
      controlProductoList,
      newAutorizacionConfigList,
      tipoValidacion,
      upsertAutorizacionConfig,
      validateValues
    ]
  );

  const setearArregloRol = useCallback(
    async (data) => {
      const list = data.map((item) => {
        const autorizacionConfigDetalle = item;
        autorizacionConfigDetalle.cantidad = Number(item.cantidad);
        autorizacionConfigDetalle.rol = item.rol_value;
        autorizacionConfigDetalle.autorizacion_especial =
          item.autorizacion_especial;
        return autorizacionConfigDetalle;
      });

      const id = data[0].id_autorizacion_config;
      const { rowConfig } = data[0];
      const autorizacionConfigListWithRoles = newAutorizacionConfigList.map(
        (item) => {
          const autorizacionConfig = item;
          if (
            (autorizacionConfig.id && autorizacionConfig.id === id) ||
            autorizacionConfig.row === rowConfig
          ) {
            autorizacionConfig.autorizacionConfigDetalles = list;
            autorizacionConfig.editado = true;
          }
          return autorizacionConfig;
        }
      );
      setNewAutorizacionConfigList(autorizacionConfigListWithRoles);
      if (
        tipoValidacion === 'zona' ||
        tipoValidacion === 'vehiculo' ||
        tipoValidacion === 'actividad'
      )
        await update(autorizacionConfigListWithRoles);
    },
    [newAutorizacionConfigList, tipoValidacion, update]
  );

  const setearAprobadorGerencial = useCallback(
    async (list, data) => {
      if (list && list.length > 0) {
        const aprobadorToUpdate = list.filter((item) => item !== null)[0];
        const autorizacionConfigListWithAprobador = newAutorizacionConfigList.map(
          (item) => {
            const autorizacionConfig = item;
            if (
              autorizacionConfig.id === data.id ||
              autorizacionConfig.row === data.row
            ) {
              autorizacionConfig.id_usuario = aprobadorToUpdate.id;
              autorizacionConfig.usuario = aprobadorToUpdate;
              autorizacionConfig.editado = true;
              autorizacionConfig.aprobadorEditado = true;
            }
            return autorizacionConfig;
          }
        );

        setNewAutorizacionConfigList(autorizacionConfigListWithAprobador);
        if (
          tipoValidacion === 'zona' ||
          tipoValidacion === 'vehiculo' ||
          tipoValidacion === 'actividad'
        )
          await update(autorizacionConfigListWithAprobador);
      }
    },
    [newAutorizacionConfigList, tipoValidacion, update]
  );

  const setearEjecutivoCartera = async (list, data) => {
    if (list && list.length > 0) {
      const ejecutivoToUpdate = list.filter((item) => item !== null)[0];
      const autorizacionConfigListWithEjecutivo = newAutorizacionConfigList.map(
        (item) => {
          const autorizacionConfig = item;
          if (
            autorizacionConfig.id === data.id ||
            autorizacionConfig.row === data.row
          ) {
            autorizacionConfig.id_ejecutivo_cartera = ejecutivoToUpdate.id;
            autorizacionConfig.ejecutivoCartera = ejecutivoToUpdate;
            autorizacionConfig.editado = true;
          }
          return autorizacionConfig;
        }
      );
      setNewAutorizacionConfigList(autorizacionConfigListWithEjecutivo);
      if (
        tipoValidacion === 'zona' ||
        tipoValidacion === 'vehiculo' ||
        tipoValidacion === 'actividad'
      )
        await update(autorizacionConfigListWithEjecutivo);
    }
  };

  useEffect(() => {
    if (newAutorizacionConfig) {
      handleAdd();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newAutorizacionConfig]);

  useEffect(() => {
    if (tipo) {
      const url =
        tipoParam === 'aseguradoraProducto' ||
        tipoParam === 'aseguradoraEmpresaProducto'
          ? `auth/users/aseguradora?id=${tipo.idAseguradora}`
          : `auth/users?id=${tipo.idEmpresa}`;

      setUrlUsuarios(url);

      const usuarioEjecutivos = `${url}&grupo=EJECUTIVO`;
      setUrlUsuariosEjecutivos(usuarioEjecutivos);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipo]);

  useEffect(() => {
    getTipo();
    getAutorizacionesConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ResponsiveContainer size="large">
        <Card
          title={`Configuración de Autorización - ${tipo ? tipo.tipo : ''} - ${
            tipo ? tipo.producto.descripcion : ''
          } - ${tipoValidacionObj.tipo}`}
          style={{ textAlign: 'left' }}
        >
          <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
            <div>
              {validateMessage && (
                <>
                  <LabelValidateMessage message={validateMessage} />
                  <br />
                </>
              )}

              {count === 0 && (
                <>
                  <Row gutter={8}>
                    {' '}
                    <Col flex="none">
                      <Label>
                        No existen configuraciones de autorizaciones.
                      </Label>
                    </Col>
                  </Row>
                  <br />
                  <br />
                </>
              )}

              {
                <Spin spinning={!newAutorizacionConfigList}>
                  <Table
                    fixed
                    scroll={false}
                    style={{ width: '100%' }}
                    {...headTable()}
                    bordered
                    dataSource={
                      count > 0 &&
                      newAutorizacionConfigList &&
                      newAutorizacionConfigList
                        .filter((item) => !item.eliminado)
                        .sort((n1, n2) => n1.rango_desde - n2.rango_desde)
                    }
                    columns={count > 0 ? columnsAutorizacionConfig : []}
                    pagination={false}
                    size="small"
                    rowKey={(record) => record.row}
                  />
                </Spin>
              }

              <br />
              <br />
              {!(
                tipoValidacion === 'vehiculo' ||
                tipoValidacion === 'zona' ||
                tipoValidacion === 'actividad'
              ) &&
                newAutorizacionConfigList &&
                newAutorizacionConfigList.length > 0 &&
                count > 0 && (
                  <Button
                    type="primary"
                    // htmlType="submit"
                    icon={<SaveOutlined />}
                    onClick={() => update()}
                  >
                    Actualizar
                  </Button>
                )}
            </div>
          </Spin>
        </Card>
      </ResponsiveContainer>
    </>
  );
};

export default AutorizacionConfig;
